import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import { Text } from '../primitives/Text.js';
import styles from './InlineError.module.css';

export type InlineErrorProps = {
  children: ReactNode;
  /** Optional heading (e.g. “Erreur d'authentification”). */
  title?: string;
  className?: string;
};

/** Block error surface — border + tint; use for form/page-level messages (not inline field hints). */
export function InlineError({ children, title, className }: InlineErrorProps) {
  return (
    <div className={cx(styles.root, className)} role="alert">
      {title ? (
        <p className={styles.title}>{title}</p>
      ) : null}
      <Text size="sm" c="error" ff="body" component="div" className={styles.body}>
        {children}
      </Text>
    </div>
  );
}
